var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditbotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.278 3.60897C13.0359 6.82781 9.77842 10.0619 6.52863 13.2883C5.43898 12.2103 4.34548 11.1209 3.26733 10.0504C6.51712 6.824 9.77459 3.58993 13.0167 0.371094C14.0833 1.43007 15.1807 2.51952 16.278 3.60897Z",
    fill: "#565657"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49398 13.9574C3.96692 14.5212 2.43603 15.0888 0.84375 15.6754C1.43462 14.0984 2.00631 12.5709 2.57416 11.0586C3.54871 12.0261 4.51559 12.9899 5.49398 13.9574Z",
    fill: "#565657"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditbotIcon);
export default __webpack_public_path__ + "static/media/editbot-icon.dbbc22b28b39370624fb7dc04a11bc54.svg";
export { ForwardRef as ReactComponent };